import Button from '../Button'
import {PaperclipIcon} from '../Icon'
import React from 'react'
import styles from './styles/AttachmentView.module.scss'
import {useTranslation} from 'react-i18next'

interface AttachmentProps {
    disabled?: boolean
    multiple?: boolean
    onFiles: (files: FileList) => void
    photo?: boolean
    text?: string
}

const AttachmentView: React.FC<AttachmentProps> = (props: AttachmentProps): React.ReactElement => {
    const {
        disabled,
        multiple,
        onFiles,
        photo,
        text,
    } = props

    const {t} = useTranslation()

    const hiddenFileInput = React.useRef<HTMLInputElement>(null)

    const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (!event.currentTarget.files) {
            return
        }
        onFiles(event.currentTarget.files)
    }

    const onClick = (): void => {
        if (hiddenFileInput.current?.value) {
            // Clear value allowing selecting the same file consecutive times
            hiddenFileInput.current.value = ''
        }

        hiddenFileInput.current?.click()
    }

    return (
        <div className={`${styles.AttachmentView}`}>
            <Button
                color={photo ? undefined : 'text'}
                disabled={disabled}
                iconLeft={photo ? undefined : PaperclipIcon}
                onPress={onClick}
                text={text}
                title={photo ? t('Select photo') : t('Attach files')}
            />
            <input
                {...photo && {accept: 'image/*'}}
                disabled={disabled}
                multiple={multiple}
                onChange={onChange}
                ref={hiddenFileInput}
                tabIndex={-1}
                type='file'
            />
        </div>
    )
}

AttachmentView.defaultProps = {
    disabled: false,
    multiple: true,
    photo: false,
    text: undefined,
}

export default AttachmentView
